import type { JSX } from 'react';
import { EXPLICACAO_TABELA, rotuloTabela } from '../lib/formato.js';
import './ExplicacaoTabelas.css';

/**
 * Uma linha por opção do seletor de tabela: o que ela faz com o RT — S12.
 *
 * Fica FORA do `<label>`, ligada ao `<select>` por `aria-describedby`: dentro
 * dele, o texto entraria no nome acessível do campo, e o leitor de tela leria
 * "Tabela de preço Engenharia preço de engenharia…" a cada foco.
 *
 * Todas as linhas aparecem juntas, e não só a da opção marcada: o ORC-2026-0053
 * saiu em Engenharia com RT zerado porque o vendedor não via que a outra tabela
 * já trazia o RT embutido. A comparação é o ponto.
 *
 * Quem chama passa as tabelas **que o seu seletor oferece**, na mesma ordem: o
 * novo orçamento oferece duas (o Del Credere tem seção própria, sem seletor); o
 * "Duplicar como…" oferece as três. Explicar uma opção ausente confundiria.
 */
export function ExplicacaoTabelas({
  id,
  tabelas,
}: {
  id: string;
  tabelas: readonly string[];
}): JSX.Element {
  return (
    <div className="explicacao-tabelas" id={id}>
      {tabelas.map((code) => (
        <p key={code} className="explicacao-tabelas__linha">
          <strong>{rotuloTabela(code)}</strong> — {EXPLICACAO_TABELA[code]}
        </p>
      ))}
    </div>
  );
}
